// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8be3139","455":"fbb2f9d2","488":"e028a2b0"}[chunkId] + ".chunk.js";
};